import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import ErrorMssg from "../../Components/ErrorMssg/ErrorMssg";
import LanguageSelector from "../../Components/Language-selector";
import { useLibyaSignupLogic } from "../SignUp/libya/useLibyaSignupLogic";
import "./Marketing2Page.css";

/**
 * Libya signup flow — “esports arena / gold–violet” marketing skin.
 * Route: /marketing2
 */
const Marketing2Page = () => {
  const { t, i18n } = useTranslation();
  const {
    errMsg,
    msisdn,
    otp,
    setOtp,
    isOTP,
    setIsOTP,
    isLoading,
    isValidMsisdn,
    onSubmit,
    onVerifyOtp,
    allowOnlyNumbers,
    handleMsisdnChange,
  } = useLibyaSignupLogic();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <div className="mkt-arena" dir={i18n.dir()}>
      <div className="mkt-arena-angled" aria-hidden />
      <div className="mkt-arena-glow" aria-hidden />
      <div className="mkt-arena-inner">
        <div className="mkt-arena-topbar">
          <div className="mkt-arena-ribbon" aria-label="status">
            <span />
            LIVE ARENA
          </div>
          <LanguageSelector />
        </div>

        {!isOTP && (
          <>
            <div className="mkt-arena-hero">
              <img
                className="mkt-arena-logo servImg cptpl_logo"
                src={logo}
                alt="Gamer Club"
              />
              <h1 className="mkt-arena-title">{t("SubscribeNowText")}</h1>
              <p className="mkt-arena-sub cptpl_service d-block">
                {t(
                  "compete in tournaments and track their performance through leaderboards. It offers a space for both casual and competitive players across various games."
                )}
              </p>
            </div>

            <div className="mkt-arena-card">
              <div className="mkt-arena-form-wrap">
                <form onSubmit={onSubmit}>
                  <div className="mkt-arena-input-row">
                    <input
                      value="218"
                      readOnly
                      className="form-control mkt-arena-prefix"
                    />
                    <input
                      type="text"
                      placeholder={t("Enteryourmobilenumber")}
                      className="form-control mkt-arena-input"
                      value={msisdn}
                      onChange={handleMsisdnChange}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="tel-national"
                    />
                  </div>
                  {msisdn.length > 0 && !isValidMsisdn && (
                    <small className="mkt-arena-hint">
                      {msisdn.startsWith("218")
                        ? t(
                            "Mobile number must be 12–13 digits when starting with 218"
                          )
                        : t("Mobile number must be 9 digits")}
                    </small>
                  )}

                  <button
                    type="submit"
                    className="mkt-arena-btn cptpl_subscribe"
                    id="cta_button"
                    disabled={isLoading || !isValidMsisdn}
                  >
                    {isLoading ? t("Processing") : t("subscribe")}
                  </button>
                </form>
              </div>
            </div>

            <div className="mkt-arena-terms" style={{ direction: "rtl" }}>
              <p className="price_text price_title-2 cptpl_price">
                {t("New_subscribers_weekly_ts_libyaF")}
                <br />
                {t("New_subscribers_monthly_ts_libyaF")}
              </p>
              <p className="cptpl_terms">
                {t("New_subscribers_ts_libya_condition")}
              </p>
              <p>
                <a href="/terms">{t("terms_of_service")}</a>
                {" | "}
                <a href="/privacy">{t("privacy_policy")}</a>
              </p>
            </div>
          </>
        )}

        {isOTP && (
          <div className="mkt-arena-card" style={{ marginTop: "0.75rem" }}>
            <h2 className="mkt-arena-otp-title">{t("OTP VERIFICATION")}</h2>
            <p className="mkt-arena-otp-sub">
              {t("Enter the OTP sent to")} — <b>{msisdn}</b>
            </p>
            <form onSubmit={onVerifyOtp}>
              <input
                className="form-control mkt-arena-input text-center"
                maxLength="4"
                placeholder={t("EnteryourOTP")}
                value={otp}
                onKeyDown={allowOnlyNumbers}
                onChange={(e) => setOtp(e.target.value)}
                inputMode="numeric"
                autoComplete="one-time-code"
              />
              <button
                type="submit"
                className="mkt-arena-btn"
                disabled={isLoading || otp.length !== 4}
              >
                {isLoading ? "…" : t("Confirm")}
              </button>
              <button
                type="button"
                className="mkt-arena-btn-outline"
                onClick={() => setIsOTP(false)}
              >
                {t("Back")}
              </button>
            </form>
          </div>
        )}

       
      </div>
    </div>
  );
};

export default Marketing2Page;
